import { Injectable } from "@angular/core";
import { catchError, Observable, of } from "rxjs";
import { ServiceClientService } from "./service-client.service";
import { endpoints } from "../../environments/endpoints";
import { FilterCodeset, SavedFilter } from "../models/filter.model";
import { IResponse } from "../models/response.model";
import { HttpErrorResponse } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class FilterService {
  constructor(public serviceClientService: ServiceClientService) {}

  getAllSavedFilters(): Observable<SavedFilter[]> {
    // return of([])
        return this.serviceClientService.get(endpoints.filters).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error("Error fetching saved filters:", error);
        return of([]);
      })
    );
  }

  getCodeSet(query: FilterCodeset): Observable<any> {
    return this.serviceClientService.post(
      endpoints.filtersCodesetLookup,
      query
    );
  }

  updateFilterPrivacy(
    filterId: string,
    privateFilter: boolean
  ): Observable<any> {
    return this.serviceClientService.putInline(endpoints.filters + "/" + filterId + "/" + privateFilter);
  }

  saveFilter(filter: SavedFilter): Observable<any> {
    if (filter.id) {
      return this.serviceClientService.put(
        endpoints.filters + "/" + filter.id,
        {
          name: filter.name,
          filters: filter.filterValues,
          privateFilter: filter.privateFilter,
        }
      );
    } else {
      return this.serviceClientService.post(endpoints.filters, {
        name: filter.name,
        filters: filter.filterValues,
        privateFilter: filter.privateFilter,
      });
    }
  }

  delete(filter: SavedFilter): Observable<any> {
    if (filter && filter.id) {
      return this.serviceClientService.delete(
        endpoints.filters + "/" + filter.id
      );
    } else {
      return of(null);
    }
  }

  getDefaultFilter(): Observable<any> {
    return this.serviceClientService.get<IResponse<any>>(
      endpoints.defaultFilter
    );
  }

  setDefaultFilter(filterId: number): Observable<any> {
    return this.serviceClientService.patch(endpoints.defaultFilter, {
      filterId,
    });
  }

  deleteDefaultFilter(): Observable<any> {
    return this.serviceClientService.delete(endpoints.defaultFilter);
  }
}
